module.exports = __webpack_public_path__ + "3541db7ddc44cf6cf72977c4f808e0ec.jpg";